// import $ from 'jquery';
import debug from 'debug';

const log = debug('core/jquery_plugin/strings');

function preserveCamelCase(str) {
  let isLastCharLower = false;
  let isLastCharUpper = false;
  let isLastLastCharUpper = false;

  for (let i = 0; i < str.length; i++) {
    const c = str[i];

    if (isLastCharLower && /[a-zA-Z]/.test(c) && c.toUpperCase() === c) {
      str = str.substr(0, i) + '-' + str.substr(i);
      isLastCharLower = false;
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = true;
      i++;
    } else if (isLastCharUpper && isLastLastCharUpper && /[a-zA-Z]/.test(c) && c.toLowerCase() === c) {
      str = str.substr(0, i - 1) + '-' + str.substr(i - 1);
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = false;
      isLastCharLower = true;
    } else {
      isLastCharLower = c.toLowerCase() === c;
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = c.toUpperCase() === c;
    }
  }

  return str;
}

export function toCamelCase (str) {
  if (arguments.length > 1) {
    str = Array.from(arguments)
      .map(x => x.trim())
      .filter(x => x.length)
      .join('-');
  } else {
    str = str.trim();
  }

  if (str.length === 0) {
    return '';
  }

  if (str.length === 1) {
    return str.toLowerCase();
  }

  if (/^[a-z0-9]+$/.test(str)) {
    return str;
  }

  const hasUpperCase = str !== str.toLowerCase();

  if (hasUpperCase) {
    str = preserveCamelCase(str);
  }

  return str
    .replace(/^[_.\- ]+/, '')
    .toLowerCase()
    .replace(/[_.\- ]+(\w|$)/g, (m, p1) => p1.toUpperCase());
};


export function tmpl(str, context) {
  let result = str;

  if (result) {

    Object.keys(context)
      .forEach((item) => {
        result = result.replace(`{{${item}}}`, context[item]);
      });
  }

  return result;
}

export function $tmpl(element, context) {
  const $target = $(element);
  const templateString = $target.attr('data-text-template');
  const result = tmpl(templateString, context);

  $target.text(result);
}

/**
 * https://github.com/aishikaty/tiny-mustache
 * https://mustache.github.io/
 * @param  {String} template [description]
 * @param  {[type]} self     [description]
 * @param  {[type]} parent   [description]
 * @param  {[type]} invert   [description]
 * @return {[type]}          [description]
 */
export function mustache(template, self, parent, invert) {
  var render = mustache;
  var output = "";
  var i;

  log('mustache', {template, self, parent, invert});

  function get(ctx, path) {
    path = path.pop ? path : path.split(".");
    ctx = ctx[path.shift()] || "";
    return (0 in path) ? get(ctx, path) : ctx;
  }

  self = Array.isArray(self) ? self : (self ? [self] : []);
  self = invert ? (0 in self) ? [] : [1] : self;

  for (i = 0; i < self.length; i++) {
    var childCode = '';
    var depth = 0;
    var inverted;
    var ctx = (typeof self[i] == "object") ? self[i] : {};
        ctx = Object.assign({}, parent, ctx);
        ctx[""] = { "": self[i] };

    template.replace(/([\s\S]*?)({{((\/)|(\^)|#)(.*?)}}|$)/g,
      function (match, code, y, z, close, invert, name) {

        if (!depth) {
          output += code.replace(/{{{(.*?)}}}|{{(!?)(&?)(>?)(.*?)}}/g,
            function (match, raw, comment, isRaw, partial, name) {
              return raw ? get(ctx, raw)
                : isRaw ? get(ctx, name)
                  : partial ? render(get(ctx, name), ctx)
                    : !comment ? new Option(get(ctx, name)).innerHTML
                      : "";
            }
          );
          inverted = invert;

        } else {
          childCode += depth && !close || depth > 1 ? match : code;
        }

        if (close) {
          if (!--depth) {
            name = get(ctx, name);
            if (/^f/.test(typeof name)) {
              output += name.call(ctx, childCode, function (template) {
                return render(template, ctx);
              });
            } else {
              output += render(childCode, name, ctx, inverted);
            }
            childCode = "";
          }

        } else {
          ++depth;
        }
        log(`mustache.output.${depth}`, {output});
      }
    );
  }
  log('mustache.output', {output});
  return output;
}

export function booleanify(value) {
  const lower = value.toLowerCase();
  if (lower === 'false' || lower === '0') {
    return false;
  }
  return new Boolean(value);
}



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/lib/strings.js